import { useState } from 'react';
import { cookieHelper } from '../_helpers/cookie-helper';

export default function useToken() {
  const getToken = () => {
    const userToken = cookieHelper.getAuthToken();
    return userToken
  };

  const [token, setToken] = useState('');

  const saveToken = userToken => {
    cookieHelper.setAuthCookie(userToken);
    //sessionStorage.setItem('token', userToken);
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token,
    getToken: getToken,
  }
}
